import { Component } from "react"

/* Components */
import Icon from "../../components/Icon"


/* The mounted widget — the helper below talks to it */
let widget = null

/* Identifier of the last message */
let counter = 0


/* Widget Toast — one place for short messages about finished actions. It hangs above every
   window of the panel, so a message about a saved card is seen even from inside a modal */
class Toast extends Component {

    constructor() {
        super()

        this.state = {
            items: []
        }

        /* Timers of every message */
        this.timers = {}
    }

    componentDidMount = () => {

        /* The helper sends the messages here */
        widget = this
    }

    componentWillUnmount = () => {

        /* Clear Timers */
        Object.keys(this.timers).forEach(key => clearTimeout(this.timers[`${key}`]))

        /* Release */
        this.timers = {}
        widget = null
    }

    /* Show one message */
    show = (message, type) => {

        /* Fields */
        const { items } = this.state

        /* Check Data */
        if (!message) {
            return
        }

        /* Identifier */
        counter = counter + 1

        const item = { id: counter, message, type: type ? type : "success", leaving: false }

        /* Not more than three messages at once */
        this.setState({ items: [...items, item].slice(-3) })

        this.timers[`${item.id}`] = setTimeout(() => this.leave(item.id), 3200)
    }

    /* Start the leaving animation */
    leave = id => {

        /* Fields */
        const { items } = this.state

        this.setState({ items: items.map(item => item.id === id ? { ...item, leaving: true } : item) })

        this.timers[`${id}`] = setTimeout(() => this.remove(id), 220)
    }

    /* Take the message away */
    remove = id => {

        /* Fields */
        const { items } = this.state

        clearTimeout(this.timers[`${id}`])
        delete this.timers[`${id}`]

        this.setState({ items: items.filter(item => item.id !== id) })
    }

    /* Close the message by hand */
    close = id => {
        clearTimeout(this.timers[`${id}`])
        this.leave(id)
    }

    render = () => {

        /* Fields */
        const { items } = this.state

        /* Check Data */
        if (items.length === 0) {
            return null
        }

        return (
            <div className="toast">
                {items.map(item =>
                    <div
                        key={`${item.id}`}
                        onClick={() => this.close(item.id)}
                        className={`toast-item ${item.type} ${item.leaving ? "leaving" : ""}`}
                    >
                        <div className="toast-icon">
                            <Icon name={item.type === "error" ? "alert" : "check"} size={15} width={2.6} />
                        </div>
                        <div className="toast-message">{item.message}</div>
                    </div>
                )}
            </div>
        )
    }
}


/* Short messages from anywhere in the panel */
export const toast = {

    /* Finished action */
    success: message => {
        if (widget) {
            widget.show(message, "success")
        }
    },

    /* Action which did not go through */
    error: message => {
        if (widget) {
            widget.show(message, "error")
        }
    }
}


export default Toast
